import PropTypes from "prop-types";
import { IMAGE_BASE_PATH } from "@/config/config";
import classNames from "classnames";
import Image from "next/image";
import { memo, useState } from "react";
import MaskedInput from "react-input-mask";

import classes from "./MaskedInput.module.scss";

const Input = ({
  className,
  onBlur,
  onChange,
  name,
  placeholder,
  mask,
  value,
  error,
  hasSearchIcon,
  isSearchSubmit,
  touched,
  errorClassName,
  isHiddenInput,
  inputRef,
  disabled,
  ...restProps
}) => {
  const [isHidden, setIsHidden] = useState(isHiddenInput);

  const toggleVisible = () => {
    setIsHidden((o) => !o);
  };
  return (
    <div className={classes.inputContainer}>
      <MaskedInput
        alwaysShowMask={restProps.alwaysShowMask || false}
        className={classNames(
          classes.input,
          className,
          "inputClass form-control font-20 font-sm-14",
          {
            [classes.searchIconInputClass]:
              hasSearchIcon && !isSearchSubmit && !isHiddenInput,
            disabledInput: disabled,
          }
        )}
        mask={mask}
        maskChar={null}
        name={name}
        onBlur={onBlur}
        onChange={onChange}
        placeholder={placeholder}
        type={isHidden ? "password" : "text"}
        value={value}
        disabled={disabled}
        inputRef={(ref) => {
          if (inputRef) inputRef.current = ref;
        }}
        {...restProps}
      />
      {isHiddenInput ? (
        <button
          className={classNames(classes.inputHide, "font-20 font-sm-14")}
          onClick={toggleVisible}
          type="button"
        >
          {isHidden ? (
            <Image
              alt="show"
              src={`${IMAGE_BASE_PATH}/images/eye-close.svg`}
              width={36}
              height={36}
            />
          ) : (
            <Image
              alt="hide"
              src={`${IMAGE_BASE_PATH}/images/eye-open.svg`}
              width={36}
              height={36}
            />
          )}
        </button>
      ) : null}
      {!isHiddenInput && isSearchSubmit ? (
        <button className="submitSearchButton" type="submit">
          <Image
            alt="search"
            src={`${IMAGE_BASE_PATH}/images/search.svg`}
            width={36}
            height={36}
          />
        </button>
      ) : null}
      {touched && error ? (
        <span
          className={classNames(
            "inputErrorText font-14 font-sm-12",
            errorClassName
          )}
        >
          {error}
        </span>
      ) : null}
    </div>
  );
};

Input.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  error: PropTypes.string,
  errorClassName: PropTypes.string,
  hasSearchIcon: PropTypes.bool,
  inputRef: PropTypes.oneOfType([
    // Either a function
    PropTypes.func,
    PropTypes.shape({
      current: PropTypes.any,
    }),
  ]),
  isHiddenInput: PropTypes.bool,
  isSearchSubmit: PropTypes.bool,
  mask: PropTypes.any,
  name: PropTypes.any,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  touched: PropTypes.bool,
  type: PropTypes.string,
  value: PropTypes.string,
};

Input.defaultProps = {
  className: "",
  onBlur: () => {},
  type: "",
  onChange: () => {},
  placeholder: "Please input here",
  value: "",
  touched: false,
  error: "",
  hasSearchIcon: false,
  isSearchSubmit: false,
  errorClassName: "",
  isHiddenInput: false,
};

export default memo(Input);
